// @ts-nocheck
import "leaflet";
function initLeafletMaps() {
    if (window.mapInitialized)
        return;
    const leafletItems = document.querySelectorAll("[data-leaflet]");
    if (!leafletItems)
        return;
    window.mapInitialized = true;
    leafletItems.forEach((item) => {
        const map = L.map(item, {
            center: [51.659, 5.615],
            zoom: 13,
            preferCanvas: true,
            zoomControl: false,
        });
        // Modern monochromatic dark style
        var darkStyle = {
            color: "#ffffff",
            weight: 2,
            opacity: 1,
            fillColor: "#2c2c2c",
            fillOpacity: 0.7,
        };
        L.tileLayer("https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png", {
            attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors © <a href="https://carto.com/attributions">CARTO</a>',
            maxZoom: 19,
        }).addTo(map);
        const mapIcon = L.icon({
            iconUrl: "/wp-content/themes/the-soul/assets/img/icons/location.svg",
            iconSize: [40, 40],
            iconAnchor: [22, 94],
            popupAnchor: [-3, -76],
            shadowSize: [0, 0],
            shadowAnchor: [22, 94],
        });
        const marker = L.marker([51.659, 5.615], {
            icon: mapIcon,
            opacity: 0.5,
        }).addTo(map);
    });
}
export default initLeafletMaps;
